export default "__VITE_ASSET__Cs3KtNx6__"